import React from 'react';

const Clients: React.FC = () => {
  return (
    <div className="container-fluid clients bg-light py-5">
      <div className="container py-5">
        <div className="section-title position-relative text-center mx-auto mb-5 pb-4 wow fadeInUp"
          data-wow-delay="0.1s" style={{ maxWidth: "800px" }}>
          <h4 className="text-primary">Our Valued Clients</h4>
          <h1 className="display-4 mb-4">Trusted by Leading Organizations</h1>
          <p className="mb-1">We are proud to partner with industry leaders across various sectors, delivering exceptional water and wastewater treatment solutions that meet their unique requirements.</p>
        </div>
        
        <div className="row g-4 client-logos-grid">
          <div className="col-lg-2 col-md-3 col-sm-4 col-6 wow fadeInUp" data-wow-delay="0.1s">
            <div className="client-logo-item">
              <img src="logos/Picture1.jpg" className="img-fluid" alt="Client Logo" />
            </div>
          </div>
          <div className="col-lg-2 col-md-3 col-sm-4 col-6 wow fadeInUp" data-wow-delay="0.15s">
            <div className="client-logo-item">
              <img src="logos/Picture2.png" className="img-fluid" alt="Client Logo" />
            </div>
          </div>
          <div className="col-lg-2 col-md-3 col-sm-4 col-6 wow fadeInUp" data-wow-delay="0.2s">
            <div className="client-logo-item">
              <img src="logos/Picture3.jpg" className="img-fluid" alt="Client Logo" />
            </div>
          </div>
          <div className="col-lg-2 col-md-3 col-sm-4 col-6 wow fadeInUp" data-wow-delay="0.25s">
            <div className="client-logo-item">
              <img src="logos/Picture5.jpg" className="img-fluid" alt="Client Logo" />
            </div>
          </div>
          <div className="col-lg-2 col-md-3 col-sm-4 col-6 wow fadeInUp" data-wow-delay="0.3s">
            <div className="client-logo-item">
              <img src="logos/Picture6.png" className="img-fluid" alt="Client Logo" />
            </div>
          </div>
          <div className="col-lg-2 col-md-3 col-sm-4 col-6 wow fadeInUp" data-wow-delay="0.35s">
            <div className="client-logo-item">
              <img src="logos/Picture7.png" className="img-fluid" alt="Client Logo" />
            </div>
          </div>
          <div className="col-lg-2 col-md-3 col-sm-4 col-6 wow fadeInUp" data-wow-delay="0.4s">
            <div className="client-logo-item">
              <img src="logos/Picture8.jpg" className="img-fluid" alt="Client Logo" />
            </div>
          </div>
          <div className="col-lg-2 col-md-3 col-sm-4 col-6 wow fadeInUp" data-wow-delay="0.45s">
            <div className="client-logo-item">
              <img src="logos/Picture9.png" className="img-fluid" alt="Client Logo" />
            </div>
          </div>
          <div className="col-lg-2 col-md-3 col-sm-4 col-6 wow fadeInUp" data-wow-delay="0.5s">
            <div className="client-logo-item">
              <img src="logos/Picture10.png" className="img-fluid" alt="Client Logo" />
            </div>
          </div>
          <div className="col-lg-2 col-md-3 col-sm-4 col-6 wow fadeInUp" data-wow-delay="0.55s">
            <div className="client-logo-item">
              <img src="logos/Picture11.png" className="img-fluid" alt="Client Logo" />
            </div>
          </div>
          <div className="col-lg-2 col-md-3 col-sm-4 col-6 wow fadeInUp" data-wow-delay="0.6s">
            <div className="client-logo-item">
              <img src="logos/Picture12.jpg" className="img-fluid" alt="Client Logo" />
            </div>
          </div>
          <div className="col-lg-2 col-md-3 col-sm-4 col-6 wow fadeInUp" data-wow-delay="0.65s">
            <div className="client-logo-item">
              <img src="logos/Picture13.png" className="img-fluid" alt="Client Logo" />
            </div>
          </div>
          <div className="col-lg-2 col-md-3 col-sm-4 col-6 wow fadeInUp" data-wow-delay="0.7s">
            <div className="client-logo-item">
              <img src="logos/Picture14.png" className="img-fluid" alt="Client Logo" />
            </div>
          </div>
          <div className="col-lg-2 col-md-3 col-sm-4 col-6 wow fadeInUp" data-wow-delay="0.75s">
            <div className="client-logo-item">
              <img src="logos/Picture15.png" className="img-fluid" alt="Client Logo" />
            </div>
          </div>
          <div className="col-lg-2 col-md-3 col-sm-4 col-6 wow fadeInUp" data-wow-delay="0.8s">
            <div className="client-logo-item">
              <img src="logos/Picture16.png" className="img-fluid" alt="Client Logo" />
            </div>
          </div>
          <div className="col-lg-2 col-md-3 col-sm-4 col-6 wow fadeInUp" data-wow-delay="0.85s">
            <div className="client-logo-item">
              <img src="logos/Picture17.png" className="img-fluid" alt="Client Logo" />
            </div>
          </div>
          <div className="col-lg-2 col-md-3 col-sm-4 col-6 wow fadeInUp" data-wow-delay="0.9s">
            <div className="client-logo-item">
              <img src="logos/Picture18_1.png" className="img-fluid" alt="Client Logo" />
            </div>
          </div>
          <div className="col-lg-2 col-md-3 col-sm-4 col-6 wow fadeInUp" data-wow-delay="0.95s">
            <div className="client-logo-item">
              <img src="logos/Picture18_2.png" className="img-fluid" alt="Client Logo" />
            </div>
          </div>
          <div className="col-lg-2 col-md-3 col-sm-4 col-6 wow fadeInUp" data-wow-delay="1s">
            <div className="client-logo-item">
              <img src="logos/Picture18_3.png" className="img-fluid" alt="Client Logo" />
            </div>
          </div>
          <div className="col-lg-2 col-md-3 col-sm-4 col-6 wow fadeInUp" data-wow-delay="1.05s">
            <div className="client-logo-item">
              <img src="logos/Picture18_4.png" className="img-fluid" alt="Client Logo" />
            </div>
          </div>
          <div className="col-lg-2 col-md-3 col-sm-4 col-6 wow fadeInUp" data-wow-delay="1.1s">
            <div className="client-logo-item">
              <img src="logos/Picture18_5.png" className="img-fluid" alt="Client Logo" />
            </div>
          </div>
          <div className="col-lg-2 col-md-3 col-sm-4 col-6 wow fadeInUp" data-wow-delay="1.15s">
            <div className="client-logo-item">
              <img src="logos/Picture19.jpg" className="img-fluid" alt="Client Logo" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Clients;
